export default __webpack_public_path__ + "static/media/Rogue's Rest Teleport.2852aa2f.PNG";